module.exports = __webpack_public_path__ + "static/media/study 220208.61c65b80.png";